/* eslint-disable max-len */
import { CART_VIEW_PREFERENCE } from '../constants/constants';
import { goToUrl } from './utils';

export const onApprove = async (
  paypalData,
  orderId,
  isRegularPaypal,
  returnUrl,
  triggerSubmit,
  payPalInitOrderId,
) => {
  try {
    if (isRegularPaypal) {
      const parsedReturnUrl = new URL(returnUrl);
      if (parsedReturnUrl.searchParams.get('navigation') === 'regularPaypal') {
        triggerSubmit(null, paypalData);
        return true;
      }
      return false;
    }
    const cartId = (orderId && orderId !== '') ? orderId : payPalInitOrderId;
    const payPalReviewUrl = '/checkout?cartId=' + cartId + '&orderId=' + cartId
      + '&token=' + paypalData?.orderID + '&payerID=' + paypalData?.payerID
      + '&navigation=expressPaypal';
    goToUrl(payPalReviewUrl);

  } catch (error) {
    console.log('Paypal on approve error: ' + error);
  }
  return true;
};

export function addAlert(showAlert) {
  try {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-unused-expressions
      window?.LIFE_CYCLE_EVENT_BUS?.trigger('checkout.addPaypalAlert', { showAlert });
    }
  } catch (err) {
    console.error(err);
  }
}

export const getCartViewType = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(CART_VIEW_PREFERENCE) === 'List' ? 'list' : 'detail';
  }
  return 'detail';
};

export const experienceType = (checkoutType) => {
  return checkoutType === 'giftcardReload'
    ? 'GC_R' : 'INITPAYPAL';
};
